import { createSearchParams, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useLowercaseQueryString } from './useLowercaseQueryString';

export const useConfirmationNavigate = () => {
  const navigate = useNavigate();
  const { queryStrings } = useLowercaseQueryString();
  const { df_id, fr_id, proxy_id, proxy_type, idb } = queryStrings;

  const handleConfirmation = useCallback(() => {
    navigate(
      {
        pathname: '/confirmation',
        search: `?${createSearchParams({
          ...(idb && { idb }),
          df_id,
          mfc_pref: 'T',
          FR_ID: fr_id,
          PROXY_ID: proxy_id,
          PROXY_TYPE: proxy_type,
          [`${df_id}.donation`]: 'completed',
        })}`,
      },
      { replace: true }
    );
  }, [navigate, idb, df_id, fr_id, proxy_id, proxy_type]);

  return { handleConfirmation };
};
